import styled from 'styled-components';
import { IBotDetail } from 'interface';
import { FC, ReactNode } from 'react';

const CustomContextSidebarStyle = styled.div`
    .source-name {
        color: ${(props: { botDetail: IBotDetail }) => props.botDetail.botSettings.sendIconBackgroundColor} !important;
    }

    .context-resource {
        color: ${(props: { botDetail: IBotDetail }) => props.botDetail.botSettings.sendIconBackgroundColor} !important;
    }

    .accordion-icon {
        color: ${(props: { botDetail: IBotDetail }) => props.botDetail.botSettings.sendIconBackgroundColor} !important;
    }
`;

const CustomContextViewStyle: FC<{ botDetail: IBotDetail; children: ReactNode }> = ({ botDetail, children }) => {
    return <CustomContextSidebarStyle botDetail={botDetail}>{children}</CustomContextSidebarStyle>;
};

export default CustomContextViewStyle;
